export const initialState = {
  loading: false,
  filterModalSubcategories :"All",
  currentCategoryFiltered : null,
  response: { message: null, error: null },
  settings:[]
};
